import { store as permission, PermissionStore, PermissionState } from '@/store/modules/permission'
import { store as tagViews, TagsStore, TagsViewState } from '@/store/modules/tagsview'
import { store as user, UserStore, UserState } from '@/store/modules/user'

import { createStore, createLogger } from 'vuex'

export interface RootState {
  permission: PermissionState
  tagViews: TagsViewState
  user: UserState
}

export type Store = PermissionStore<Pick<RootState, 'permission'>> & TagsStore<Pick<RootState, 'tagViews'>> & UserStore<Pick<RootState, 'user'>>

const debug = process.env.NODE_ENV !== 'production'
const plugins = debug ? [createLogger({})] : []

export const store = createStore({
  plugins,
  modules: {
    permission,
    tagViews,
    user,
  },
})

export function useStore(): Store {
  return store as Store
}
